/* al-pixel.js - Meta browser events for the Anagen Lab storefront.

   Purchase is deliberately NOT here. The Shopify order webhook
   (-> mumscience.co.uk/api/shopify-order) is the single source of truth for
   revenue, and firing a second Purchase from the browser would double-count it.
   What that webhook cannot supply is everything BEFORE the sale, which is what
   a campaign pointed straight at the PDP has to optimise on: ViewContent,
   AddToCart, InitiateCheckout.

   The second job here matters as much as the first. That webhook matches an
   order to an ad click by reading _fbc / _fbp out of the order's note
   attributes. Traffic coming through the mumscience funnel gets those written
   by anagen.js. An ad pointed straight at this product page does not - so the
   Purchase used to land with no click attached to it at all. syncAttrs() writes
   them onto the cart as soon as there is a cart to write them to.

   Config comes from window.AL_PX, rendered by layout/theme.liquid. */
(function () {
  "use strict";

  var CFG = window.AL_PX || {};
  var ID  = CFG.pixel || "1395000652297770";
  var CUR = CFG.currency || "GBP";
  if (window.__alPixel) return;
  window.__alPixel = true;

  /* ---------- internal opt-out ----------
     Same switch as ms-pixel.js on mumscience: ?ms_optout=1 once per browser and
     this machine stops firing real events into the ad account. Per-origin, so it
     has to be set on this domain as well as on mumscience. */
  var qs;
  try { qs = new URLSearchParams(location.search); } catch (e) { qs = { get: function () { return null; } }; }
  try {
    var oo = qs.get("ms_optout");
    if (oo === "1") localStorage.setItem("ms_opt", "1");
    if (oo === "0") localStorage.removeItem("ms_opt");
    if (localStorage.getItem("ms_opt") === "1") return;
  } catch (e) {}

  /* ---------- cookies ---------- */
  function ck(n) {
    try {
      var m = document.cookie.match("(^|;)\\s*" + n + "\\s*=\\s*([^;]*)");
      return m ? decodeURIComponent(m[2]) : "";
    } catch (e) { return ""; }
  }
  function setck(n, v, days) {
    try {
      document.cookie = n + "=" + v + "; path=/; max-age=" + (days * 86400) +
        "; SameSite=Lax" + (location.protocol === "https:" ? "; Secure" : "");
    } catch (e) {}
  }
  function rnd() { return String(Math.floor(Math.random() * 1e10)); }

  /* fbevents.js writes _fbc/_fbp itself, but only once it has loaded. Seeding
     them synchronously means a fast add-to-cart still has an identity to carry,
     and guarantees there is something for syncAttrs to put on the cart even if
     the script is blocked outright. Both use Meta's own fb.1.<ts>.<x> format,
     so fbevents adopts them rather than replacing them. */
  var fbclid = qs.get("fbclid") || "";
  /* A fresh fbclid in the URL always wins. She may have clicked a DIFFERENT ad
     since her last visit, and "only set it if absent" kept the first click ID
     for 90 days - so the wrong ad got credit for the sale. fbevents.js
     overwrites the cookie on a new click; this mirrors that, because the value
     written here is the one that rides onto the cart and from there onto the
     order that the server-side Purchase is matched with. */
  if (fbclid) {
    var had = ck("_fbc");
    if (!had || had.indexOf("." + fbclid) === -1) {
      var clickTs = Date.now();
      setck("_fbc", "fb.1." + clickTs + "." + fbclid, 90);
      /* The server rebuilds fbc from a bare fbclid when cookies were blocked, and
         Meta expects fb.1.<when the click landed>.<id>. It was stamping the order
         time instead, which can be days later - a value Meta reads as modified.
         Park the real one where the cart sync can carry it. */
      try { localStorage.setItem("al_fbc_ts", String(clickTs)); } catch (e) {}
    }
  }
  if (!ck("_fbp")) setck("_fbp", "fb.1." + Date.now() + "." + rnd(), 90);

  /* a stable id for this browser, sent as external_id and carried to the order */
  var VID = "";
  try {
    VID = localStorage.getItem("al_vid") || "";
    if (!VID) { VID = rnd() + rnd(); localStorage.setItem("al_vid", VID); }
  } catch (e) {}

  /* ---------- consent ----------
     There is no cookie banner on this theme today. If one is ever turned on in
     Shopify's customer privacy settings, honour it rather than firing anyway. */
  function allowed() {
    try {
      var p = window.Shopify && window.Shopify.customerPrivacy;
      if (p && typeof p.analyticsProcessingAllowed === "function") {
        return p.analyticsProcessingAllowed() !== false && p.marketingAllowed() !== false;
      }
    } catch (e) {}
    return true;
  }

  /* ---------- Meta base code ---------- */
  !function (f, b, e, v, n, t, s) {
    if (f.fbq) return; n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
    t = b.createElement(e); t.async = !0; t.src = v;
    s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  }(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");

  /* ---------- server-side mirror ----------
     Every event now goes out twice: once from the browser and once from
     mumscience.co.uk/api/capi, carrying the SAME event id. Meta collapses the
     pair into one event, so nothing double counts — but if an ad blocker or iOS
     eats the browser copy, the server copy still lands. That is the whole point:
     coverage, not extra events.

     Sent as a text/plain beacon rather than JSON so it counts as a CORS simple
     request and skips the preflight round trip. The endpoint reads the body with
     request.json() either way. */
  var CAPI = CFG.capi || "https://mumscience.co.uk/api/capi";
  function eid() {
    return Date.now().toString(36) + "-" + rnd().slice(0, 6) + "-" + rnd().slice(0, 4);
  }
  function mirror(name, id, cd) {
    if (!CAPI) return;
    try {
      var u = {};
      /* read the cookies now, not at load: fbevents may have refreshed them */
      var c = ck("_fbc"); if (c) u.fbc = c;
      var p = ck("_fbp"); if (p) u.fbp = p;
      if (fbclid) u.fbclid = fbclid;
      if (VID) u.xid = VID;
      for (var k in AM) u[k] = AM[k];
      var ct = 0;
      try { ct = parseInt(localStorage.getItem("al_fbc_ts"), 10) || 0; } catch (e) {}
      var body = JSON.stringify({ e: [{
        n: name, id: id, t: Math.floor(Date.now() / 1000),
        ct: ct || undefined, url: location.href, u: u,
        cd: (cd && Object.keys(cd).length) ? cd : undefined
      }] });
      if (!(navigator.sendBeacon && navigator.sendBeacon(CAPI, new Blob([body], { type: "text/plain;charset=UTF-8" })))) {
        fetch(CAPI, {
          method: "POST", mode: "cors", keepalive: true,
          headers: { "Content-Type": "text/plain;charset=UTF-8" }, body: body
        }).catch(function () {});
      }
    } catch (e) {}
  }

  function track(name, data, custom) {
    if (!allowed()) return;
    if (landing) data = Object.assign({}, data || {}, { landing_page: landing.page });
    var id = eid();
    try { fbq(custom ? "trackCustom" : "track", name, data || {}, { eventID: id }); } catch (e) {}
    mirror(name, id, data);
    firstParty(name, data || {}, id);
  }

  /* The landing source is kept separately from the current page, so an
     article -> product -> cart journey retains its origin for the order. */
  var landing = null;
  var clearLanding = false;
  function rememberLanding() {
    if (!allowed()) return;
    try {
      var tag = CFG.landingPage || qs.get("al_page");
      var saved = JSON.parse(sessionStorage.getItem("al_landing_attribution") || "null");
      if (saved && Date.now() - saved.time < 1800000) landing = saved;
      if (tag === "adv" || tag === "list") {
        if (!landing || landing.page !== tag || CFG.landingPage) {
          landing = { page: tag, path: location.pathname, time: Date.now(), params: {} };
        }
        ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "utm_id", "fbclid", "gclid"].forEach(function (k) {
          var v = qs.get(k); if (v) landing.params[k] = String(v).slice(0, 500);
        });
        sessionStorage.setItem("al_landing_attribution", JSON.stringify(landing));
      } else if (qs.get("fbclid") || qs.get("utm_campaign") || qs.get("al_page")) {
        landing = null;
        clearLanding = true;
        sessionStorage.removeItem("al_landing_attribution");
      }
    } catch (e) {
      var fallbackTag = CFG.landingPage || qs.get("al_page");
      if (fallbackTag === "adv" || fallbackTag === "list") {
        landing = { page: fallbackTag, path: location.pathname, params: {} };
      }
    }
  }
  rememberLanding();

  function firstParty(name, data, eventId) {
    if (!landing || !allowed()) return;
    var names = { PageView: "page_view", ViewContent: "product_view", AddToCart: "add_to_cart", AdvertorialCTA: "offer_click", ScrollDepth: "scroll", ReadTime: "read_time", ArticleSection: "section_view" };
    if (!names[name]) return;
    try {
      var sid = sessionStorage.getItem("al_sid");
      if (!sid) { sid = rnd() + rnd(); sessionStorage.setItem("al_sid", sid); }
      var utm = Object.assign({}, landing.params);
      ["utm_source", "utm_medium", "utm_campaign", "utm_content", "fbclid"].forEach(function (key) {
        if (qs.get(key)) utm[key] = qs.get(key);
      });
      var body = JSON.stringify([{
        ts: new Date().toISOString(), vid: VID, sid: sid, qid: "",
        page: location.pathname, ev: names[name],
        val: data.scroll_depth || data.seconds || null,
        meta: { landing_page: landing.page, event_id: eventId, cta_position: data.cta_position || null, landing_variant: CFG.landingVariant || null, landing_path: landing.path, section: data.section || null },
        utm: utm, ref: document.referrer.slice(0, 200), ua: navigator.userAgent.slice(0, 120)
      }]);
      var endpoint = "https://mumscience.co.uk/api/event";
      if (navigator.sendBeacon && navigator.sendBeacon(endpoint, new Blob([body], { type: "text/plain;charset=UTF-8" }))) return;
      fetch(endpoint, { method: "POST", headers: { "Content-Type": "text/plain;charset=UTF-8" }, body: body, keepalive: true }).catch(function () {});
    } catch (e) {}
  }

  /* ---------- advanced matching ----------
     Everything we legitimately know about her, normalised the way Meta wants
     it: a signed-in customer's details from Liquid (CFG.am), else the email and
     first name she typed into the quiz (localStorage), else nothing. The same
     object goes to fbq init (browser) and to every mirrored event (server), so
     both sides carry identical keys and match quality is the same on each. */
  var AM = (function () {
    var lc = function (v) { return String(v == null ? "" : v).trim().toLowerCase(); };
    var norm = {
      em: lc,
      ph: function (v) { var d = String(v == null ? "" : v).replace(/\D/g, ""); if (d.length === 11 && d.charAt(0) === "0") d = "44" + d.slice(1); return d.length >= 7 ? d : ""; },
      fn: function (v) { return lc(v).replace(/[^a-z\u00e0-\u00ff]/g, ""); },
      ln: function (v) { return lc(v).replace(/[^a-z\u00e0-\u00ff]/g, ""); },
      ct: function (v) { return lc(v).replace(/[^a-z\u00e0-\u00ff]/g, ""); },
      st: function (v) { return lc(v).replace(/[^a-z]/g, ""); },
      zp: function (v) { return lc(v).replace(/[^a-z0-9]/g, ""); },
      country: function (v) { return lc(v).replace(/[^a-z]/g, "").slice(0, 2); }
    };
    var src = CFG.am || (CFG.em ? { em: CFG.em } : {});
    var out = {};
    for (var k in norm) { if (src[k]) { var v = norm[k](src[k]); if (v) out[k] = v; } }
    try {
      if (!out.em) { var e = localStorage.getItem("al_em"); if (e) out.em = norm.em(e); }
      if (!out.fn) { var f = localStorage.getItem("al_fn"); if (f) { f = norm.fn(f); if (f) out.fn = f; } }
    } catch (e) {}
    return out;
  })();
  var initAM = { external_id: VID };
  for (var amk in AM) initAM[amk] = AM[amk];
  fbq("init", ID, initAM);
  var pageViewSent = allowed();
  track("PageView", landing ? { landing_page: landing.page, page_path: location.pathname } : undefined);

  if (CFG.landingPage === "adv" || CFG.landingPage === "list") {
    var depths = {};
    var viewedSections = {};
    function observeSections() {
      if (!allowed() || !('IntersectionObserver' in window)) return;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || !allowed()) return;
          var section = entry.target.getAttribute('data-al-stage');
          if (!viewedSections[section]) {
            viewedSections[section] = true;
            firstParty('ArticleSection', { section: section }, eid());
          }
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.35 });
      document.querySelectorAll('[data-al-stage]').forEach(function (element) {
        if (!viewedSections[element.getAttribute('data-al-stage')]) observer.observe(element);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeSections, { once: true });
    else observeSections();
    document.addEventListener('visitorConsentCollected', observeSections);
    function landingEvent(name, extra) {
      if (!allowed()) return;
      var data = { landing_page: CFG.landingPage, page_path: location.pathname };
      for (var k in extra) data[k] = extra[k];
      track(name, data, true);
    }
    function landingView() {
      if (!allowed()) return;
      rememberLanding();
      if (!pageViewSent) {
        pageViewSent = true;
        track("PageView", { landing_page: CFG.landingPage, page_path: location.pathname });
      }
    }
    landingView();
    document.addEventListener("visitorConsentCollected", landingView);
    document.addEventListener("click", function (e) {
      var link = e.target && e.target.closest && e.target.closest("a[data-al-landing-cta]");
      if (!link) return;
      landingEvent("AdvertorialCTA", {
        cta_position: link.getAttribute("data-al-landing-cta"),
        destination_path: new URL(link.href, location.href).pathname
      });
    }, true);
    window.addEventListener("scroll", function () {
      if (!allowed()) return;
      var height = document.documentElement.scrollHeight - window.innerHeight;
      if (height <= 0) return;
      var percent = Math.min(100, Math.round(window.scrollY / height * 100));
      [25, 50, 75, 100].forEach(function (depth) {
        if (percent >= depth && !depths[depth]) {
          depths[depth] = true;
          landingEvent("ScrollDepth", { scroll_depth: depth });
        }
      });
    }, { passive: true });
    var readingSeconds = 0;
    setInterval(function () {
      if (!allowed() || document.visibilityState !== "visible") return;
      readingSeconds++;
      if ([5, 15, 30, 60, 120, 240].indexOf(readingSeconds) !== -1) {
        landingEvent("ReadTime", { seconds: readingSeconds });
      }
    }, 1000);
  }

  /* ---------- ViewContent ----------
     Once per page load, on the variant the buybox is actually showing.

     Liquid's selected_or_first_available_variant is the FIRST variant - on this
     product that is Buy 1 Get 1 at 45. The buybox preselects Buy 2 Get 3 at 90
     in its own script, so trusting Liquid reported the wrong variant at the
     wrong price, and Meta saw ViewContent 45 followed by AddToCart 90 on the
     same bundle. Read the form instead, and price it from the variant map.

     The selection is made by the buybox's own script, which may not have run
     when this deferred file executes, so the read waits for the page to settle
     rather than firing against a half-built form. */
  function fireViewContent() {
    if (!CFG.product || !CFG.product.variant) return;
    var id = String(CFG.product.variant), price = CFG.product.price || 0;
    try {
      var f = document.querySelector('[name="id"]');
      var picked = f && f.value ? String(f.value) : "";
      var list = (CFG.product.variants || []);
      for (var i = 0; i < list.length; i++) {
        if (String(list[i].id) === picked) { id = picked; price = list[i].price; break; }
      }
    } catch (e) {}
    track("ViewContent", {
      content_ids: [id],
      content_type: "product",
      content_name: CFG.product.title || "",
      contents: [{ id: id, quantity: 1, item_price: price }],
      value: price,
      currency: CUR
    });
  }

  if (CFG.product && CFG.product.variant) {
    if (document.readyState === "complete") setTimeout(fireViewContent, 250);
    else window.addEventListener("load", function () { setTimeout(fireViewContent, 250); }, { once: true });
  }

  /* ---------- the running cart ---------- */
  var CART = { total: (CFG.cart && CFG.cart.total) || 0, count: (CFG.cart && CFG.cart.count) || 0 };
  function refreshCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (c) { CART = { total: (c.total_price || 0) / 100, count: c.item_count || 0 }; return c; })
      .catch(function () { return null; });
  }

  /* ---------- AddToCart ----------
     Hooked on the request rather than the button. This theme's add-to-cart is
     bound in global.js, the bundle's free applicator is added by a second
     fetch in main-product-cuivre.liquid, and the cart drawer has its own
     handlers - catching /cart/add.js catches all three and cannot be broken by
     a markup change. */
  var pend = [], addTimer = null;

  function onAdd(d) {
    var items = d && d.items ? d.items : (d && (d.id || d.variant_id) ? [d] : []);
    if (!items.length) return;
    pend = pend.concat(items);
    clearTimeout(addTimer);
    /* The bundle adds the serum and then the free applicator as two separate
       requests. One AddToCart describing both is what actually happened; two
       events, the second worth nothing, would drag the average value down. */
    addTimer = setTimeout(flushAdd, 700);
  }

  function flushAdd() {
    var items = pend; pend = [];
    if (!items.length) return;
    var contents = items.map(function (it) {
      return {
        id: String(it.variant_id || it.id || ""),
        quantity: it.quantity || 1,
        item_price: ((it.final_price != null ? it.final_price : it.price) || 0) / 100
      };
    });
    var value = items.reduce(function (n, it) {
      return n + (((it.final_line_price != null ? it.final_line_price : it.line_price) || 0) / 100);
    }, 0);
    track("AddToCart", {
      content_ids: contents.map(function (c) { return c.id; }),
      content_type: "product",
      content_name: (items[0].product_title || items[0].title || ""),
      contents: contents,
      num_items: items.reduce(function (n, it) { return n + (it.quantity || 1); }, 0),
      value: value,
      currency: CUR
    });
    refreshCart().then(syncAttrs);
    setTimeout(function () { lastSync = ""; refreshCart().then(syncAttrs); }, 4000);   /* belt and braces: order #1010 left with nothing on the cart */
  }

  /* A path that adds to cart and then navigates straight away (the quiz's
     buy button goes /cart/add.js -> /cart in one breath) unloads the page
     before the 700ms debounce above fires, so Meta never saw the AddToCart
     even though the item was in the cart. Two guards: any script can ask for
     the pending add to go out now, and pagehide flushes whatever is left. */
  window.__alFlushAdd = function () { clearTimeout(addTimer); addTimer = null; flushAdd(); };
  window.addEventListener("pagehide", function () { if (pend.length) { clearTimeout(addTimer); addTimer = null; flushAdd(); } });

  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function (input, init) {
      var url = "";
      try { url = typeof input === "string" ? input : (input && input.url) || ""; } catch (e) {}
      var p = _fetch.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function (r) {
          if (!r || !r.ok) return;
          try { r.clone().json().then(onAdd).catch(function () {}); } catch (e) {}
        }).catch(function () {});
      } else if (/\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(url) && !(init && init.headers && init.headers["X-AL-Sync"])) {
        /* someone else touched the cart (drawer quantity, a discount app, the
           bundle script): make sure the click is still on it afterwards */
        p.then(function (r) {
          if (!r || !r.ok) return;
          try { r.clone().json().then(function (c) { CART = { total: (c.total_price || 0) / 100, count: c.item_count || 0 }; if (!(c.attributes && c.attributes._fbp)) lastSync = ""; syncAttrs(); }).catch(function () {}); } catch (e) {}
        }).catch(function () {});
      }
      return p;
    };
  }

  /* older paths in this theme still use XHR */
  var _open = XMLHttpRequest.prototype.open, _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__alUrl = u || ""; return _open.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var x = this;
    if (/\/cart\/add(\.js)?(\?|$)/.test(x.__alUrl || "")) {
      x.addEventListener("load", function () {
        try { if (x.status >= 200 && x.status < 300) onAdd(JSON.parse(x.responseText)); } catch (e) {}
      });
    }
    return _send.apply(this, arguments);
  };

  /* ---------- leaving the storefront ----------
     InitiateCheckout used to fire from here, on a click of the ordinary
     checkout button. That was only ever half the story: PayPal, Shop Pay,
     Apple Pay and Google Pay render inside cross-origin iframes, so a listener
     on this document never sees those clicks - and a buyer using one of them
     reached checkout with no InitiateCheckout at all. Order #1008 was paid by
     PayPal, which is exactly why Meta showed 1 Purchase against 0 checkouts.

     IC now fires from the custom web pixel on Shopify's checkout_started
     event, which happens on the checkout itself and so catches every payment
     method. It is NOT fired here any more - doing both would double-count the
     ordinary path.

     The click handler stays, because it does a second job that still matters:
     syncAttrs() writes _fbc/_fbp onto the cart so the server-side Purchase
     webhook can match the order back to the ad click. */
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest('[name="checkout"], .cart__checkout-button, a[href*="/checkout"], [data-al-checkout]')) return;
    syncAttrs();                       /* last chance before she leaves the storefront */
  }, true);

  /* ---------- carry the click onto the order ----------
     Only non-empty values are sent. /cart/update.js treats an empty string as
     "delete this attribute", so writing blanks would wipe the richer set that
     anagen.js already puts there for quiz traffic. */
  var lastSync = "", retries = 0;
  function syncAttrs(force) {
    if (!allowed()) return;
    if (!CART.count && !force) return;
    var fbc = ck("_fbc"), fbp = ck("_fbp");
    if (!fbp) { setck("_fbp", "fb.1." + Date.now() + "." + rnd(), 90); fbp = ck("_fbp"); }   /* the seed at load can be refused; try again now */
    var a = {};
    if (clearLanding) {
      a.al_landing_page = "";
      a.al_landing_path = "";
    }
    if (landing && allowed()) {
      a.al_landing_page = landing.page;
      a.al_landing_path = landing.path;
      if (CFG.landingPage || qs.get("al_page") === landing.page) a.al_page = landing.page;
      for (var lk in landing.params) {
        if (landing.params[lk]) a[lk] = landing.params[lk];
      }
    }
    if (fbc) { a._fbc = fbc; a.fbc = fbc; }
    if (fbp) { a._fbp = fbp; a.fbp = fbp; }
    if (fbclid) {
      a.fbclid = fbclid;
      try { var cts = localStorage.getItem("al_fbc_ts"); if (cts) a.fbclid_ts = cts; } catch (e) {}
    }
    if (VID) a.vid = VID;
    ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach(function (k) {
      var v = qs.get(k); if (v) a[k] = String(v).slice(0, 200);
    });
    if (!a._fbc && !a._fbp && !a.vid) return;   /* vid alone still lets the server match the order (external_id) */
    /* A link pasted into an ad's body copy carries no UTMs - Meta only applies
       the URL-parameters field to the destination button. Facebook's link shim
       still appends fbclid, so the click IS from an ad; labelling it "direct"
       because utm_source is missing would hide that traffic in our own
       reporting. An fbclid present and no utm_source means exactly one thing. */
    /* fbclid is read from THIS page's query string, but the cart is usually
       stamped a navigation or two later, by which time the URL is clean - so
       this fell through to "direct" on real ad clicks that added to cart
       anywhere but the landing page. Order #1008 is exactly that: a live
       _fbc, labelled direct. The _fbc cookie is the durable form of the same
       signal - it is only ever written when an fbclid was seen - and it is
       the cookie Meta itself attributes on, so reading it here keeps our
       reporting and Meta's telling the same story. */
    if (!a.hs_source) a.hs_source = qs.get("utm_source") || ((fbclid || fbc) ? "meta" : "direct");
    a.hs_brand = "anagen";

    var sig = JSON.stringify(a);
    if (sig === lastSync) return;
    lastSync = sig;

    try {
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json", "X-AL-Sync": "1" },
        credentials: "same-origin",
        keepalive: true,
        body: JSON.stringify({ attributes: a })
      }).then(function (r) { return r && r.ok ? r.json() : null; })
        .then(function (c) {
          /* read back what Shopify kept; if the click is not on the cart, go again once */
          var got = c && c.attributes && (c.attributes._fbp || c.attributes._fbc || c.attributes.vid);
          if (got) { retries = 0; }
          else if (retries++ < 2) { lastSync = ""; setTimeout(function () { syncAttrs(true); }, 1500); }
        })
        .catch(function () { lastSync = ""; });
    } catch (e) { lastSync = ""; }
  }

  /* last chance, every path: Shop Pay / PayPal / Apple Pay leave the page from
     inside their own iframes, which no click listener here can see. pagehide
     fires for all of them; the write is keepalive so it survives the unload. */
  window.addEventListener("pagehide", function () { lastSync = ""; syncAttrs(true); });
  document.addEventListener("visibilitychange", function () { if (document.hidden) { lastSync = ""; syncAttrs(true); } });

  /* a cart may already exist when she lands - stamp it straight away */
  if (CART.count) syncAttrs(); else refreshCart().then(syncAttrs);
}());
